import React, { useCallback, useState } from "react";
import { Button, ModalDialog } from "@culturehq/components";

import { Trans } from "app/utils";

import BadgeIcon from "components/display/BadgeIcon";
import ChqModalDialog from "components/common/ChqModalDialog";
import SurveyTake from "./SurveyTake";

const SurveyAvailable = ({ children, onSurveyComplete, survey }) => {
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => setOpen(true), [setOpen]);
  const onClose = useCallback(() => setOpen(false), [setOpen]);

  const onComplete = useCallback(
    () => {
      setOpen(false);
      onSurveyComplete(survey);
    },
    [setOpen, onSurveyComplete, survey]
  );

  return (
    <>
      <Button icon="clipboard" onClick={onOpen} inverted>
        <Trans>Take Survey</Trans>
      </Button>
      {children}
      {open && (
        <ChqModalDialog entrance="zoomIn" className="TakeSurveyModal" onClose={onClose}>
          <ModalDialog.Heading onClose={onClose}>
            {survey.title}
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <BadgeIcon badge="widget_survey" points={survey.points} size="medium" />
            <SurveyTake survey={survey} onSurveyComplete={onComplete} />
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default SurveyAvailable;
